import { isFunction } from 'lodash';

export default (...functions: Array<Function | null | undefined>) =>
  (...args: any) => {
    functions.forEach(f => {
      if (f != null && isFunction(f)) f(...args);
    });
  };
